<template>
    <div class="page-padding">
        <ProductBriefHeader />
        <ProductBriefsDashboard />
    </div>
</template>

<script setup lang="ts">
import ProductBriefHeader from '@/components/ProductBriefHeader.vue';
import ProductBriefsDashboard from '@/components/ProductBriefsDashboard.vue';

</script>